module.exports = __webpack_public_path__ + "static/14-7ec9bb10520acd1f26ee9b5e3ea2f87b.jpg";